import { Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { CommonService } from '../../../../../../../../shared/services/common.service';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../state/app.state';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UploadActivityIdsFileRequest } from '../../../../../../core/projects.actions';
import * as $ from 'jquery';

@Component({
    selector: 'app-upload-activity-ids-file',
    templateUrl: './upload-activity-ids-file.component.html',
    styleUrls: ['./upload-activity-ids-file.component.scss'],
    standalone: false
})
export class UploadActivityIdsFileComponent implements OnInit, OnDestroy {
  @ViewChild('fileUploadRef') fileUploadRef: ElementRef;
  acceptedFileTypes = [
    'application/vnd.ms-excel', // XLS
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // XLSX,
    'text/csv',
  ];
  errorMessages: any = {};
  errorMessageMap = {
    comment: {
      required: 'This field is required.',
    },
    changeOrderNumber: {
      required: 'This field is required.',
    },
  };

  form = this.fb.group({
    changeOrderNumber: new FormControl({ value: '', disabled: false }),
    comment: new FormControl({ value: '', disabled: false }),
  });

  file: any;
  errors: any;
  bidSheetId: any;
  projectId: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private store: Store<fromRoot.State>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {

  }

  ngOnInit() {
    this.projectId = this.data.projectId;
  }


  onSubmit() {
    const payload = {
      inputFile: this.file,
      projectId: this.projectId,
    };

    if (this.file !== undefined) {
      this.store.dispatch(UploadActivityIdsFileRequest({ payload }));
    }
  }

  openFile(id) {
    $(`#${id}`).click();
  }

  handleFileUpload() {
    this.file = this.fileUploadRef.nativeElement.files[0];
    if (this.file) {
      if (!this.acceptedFileTypes.includes(this.file?.type)) {
        this.commonService.notification('Invalid file type.', 'danger');
        return;
      }
    }

    this.fileUploadRef.nativeElement.value = '';
    this.form.markAsDirty();
  }

  removeSelectedFile() {
    this.file = null;
    this.errors = null;
    this.form.markAsPristine();
  }

  getTemplate() {
    const link = document.createElement('a');
    link.href = 'https://sitenotes-prod.s3.us-west-1.amazonaws.com/assets/activity_code_template.csv';
    link.download = 'activity_code_template.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }


  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
